export const RETURN_REALIZATION_MIN = 80;
export const RETURN_REALIZATION_MAX = 120;
export const RETURN_REALIZATION_STEP = 1;

/** Normalize persisted or user-entered realization rates to the supported range. */
export const normalizeReturnRealizationRate = rate => {
  let next = rate;
  if (next == null || next === '') next = 100;
  next = Number(next);
  if (!Number.isFinite(next)) next = 100;
  return Math.max(RETURN_REALIZATION_MIN, Math.min(RETURN_REALIZATION_MAX, Math.round(next)));
};

/** Effective rate used for cash-value calculations; 100% when the feature is off. */
export const getEffectiveReturnRealizationRate = (enabled, rate) =>
  enabled ? normalizeReturnRealizationRate(rate) : 100;
